import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import GroupSelector from '~/Common-Objects/UI/GroupSelector/GroupSelector'
import i18n from '../../../../i18n'

export default function CreateSubSelectGroup() {

    const history = useHistory()

    const [selectedGroup, setSelectedGroup] = useState(undefined)


    const forwarder = () => {
        history.push('/cp/groups/' + selectedGroup.id + '/add')
    }

    return (
        <div>
            <h4 className="mar-b10">{i18n.t('campaigns:overview.firstLetsSelectAGroup')}</h4>
            <p className="mar-b25">{i18n.t('campaigns:overview.pleaseSelectOrCreateAGroupWhereNewSubscribers')}.</p>
            <GroupSelector groupChanged={(group) => {
                setSelectedGroup(group);
            }} />
            {selectedGroup &&
                <Button
                    className="button-primary"
                    text={i18n.t('form:groupSelect.continue')}
                    onClick={forwarder}
                />}
        </div >
    );

}